import SignatureCanvas from "react-signature-canvas";
import React, {useEffect, useRef} from "react";
import {Button} from "antd";


const SignaturePad = (props) => {
    const signature = useRef();
    useEffect(() => {
    }, [signature, props.signature]);

    const clearSignature = ()=>{
        signature.current.clear();
        props.setSignature('');
        props.setSignatureRequired(true);
    };
    const mouseUp = () =>{
        const newSignature = signature.current.toDataURL('', '');
        props.setSignature(newSignature);
        props.setSignatureRequired(false);
        props.form.current.setFieldValue('elm_10_1_6a', newSignature);

    }
    return <><p>Applicant's Signature</p><div className="sig-pad" onMouseUp={mouseUp}>
        <SignatureCanvas ref={signature} canvasProps={{width: 400, height: 200, className: 'sigCanvas'}} />
        <p className="sign-above">Sign above the dotted line</p>
        <Button onClick={clearSignature}>Clear</Button>
    </div>{props.signatureRequired && <p className="required">Signature Required!</p>}</>
}
export default SignaturePad;